module.exports = __webpack_public_path__ + "img/icon_1.29e1dc29.png";